const SectionSkeleton = ({ height = "h-96" }: { height?: string }) => {
  return (
    <div className={`${height} w-full flex items-center justify-center`}>
      <div className="w-8 h-8 border-2 border-muted-foreground/20 border-t-muted-foreground/60 rounded-full animate-spin" />
    </div>
  );
};

export default SectionSkeleton;
